import { FC } from 'react';

import { Box } from '@mui/material';
import { withAuthenticatedStatus } from 'hocs/withAuthenticatedStatus/withAuthenticatedStatus';

import { TooltipComponent } from 'components/_basic/TooltipComponent';

import { IProps } from './types';
import { FormImageUploadComponent } from '../FormImageUploadComponent';

export const TooltipFormImageUpload: FC<IProps> = withAuthenticatedStatus(
  ({ isAuth, disabled, tooltipTitle = 'Please log in to upload pictures', isTooltipHidden = isAuth, ...props }) => (
    <TooltipComponent placement="top" title={tooltipTitle} isTooltipHidden={isTooltipHidden}>
      <Box>
        <FormImageUploadComponent {...props} disabled={disabled || !isAuth} />
      </Box>
    </TooltipComponent>
  ),
);
